export default {
  init() {
    var objectFitImages = require('object-fit-images');

    // JavaScript to be fired on all pages

    $('#testimonials-slider').flexslider({
          animation: "fade", //do not use slider
          slideshow: true,
          smoothHeight: true,
          touch: true,
        });

    $(function() {
      objectFitImages();

      $('#menu-primary-navigation').smartmenus({
      });
    });

    $( "#menu-trigger" ).click(function()
    {
      $( "#menu-primary-navigation" ).slideToggle();
    });

    var header = $("header.banner");
    $(window).scroll(function() {
      if ($(this).scrollTop() >= 49)
      {
        header.addClass("vit-fixed");
      } else {
        header.removeClass("vit-fixed");
      }
    });

    function prodSlideWidth(){
      var browserWidth = $(window).width();
      if (browserWidth > 767) {
        var setWidth = $(".jobs-slider").width()/3;
        $("#job-slider li").width(setWidth*3);
        $("#job-slider .job-listing-content").width(setWidth);
      }else{
        setWidth = $(".jobs-slider").width()/1;
        $("#job-slider li").width(setWidth*1);
        $("#job-slider .job-listing-content").width(setWidth);
      }
    }

    function ctaBoxesAlign(){
      $(".section-features .feature-content-single").height('auto');
      var maxFeatExcerpt = Math.max.apply(Math, $(".section-features .feature-content-single").map(function() { return $(this).height(); }));
      $(".section-features .feature-content-single").each(function() {
        $(this).height(maxFeatExcerpt);
      });
    }

    function alignRecruitmentNews(){
      $(".list-news-content").height('auto');
      var maxExcerpt = Math.max.apply(Math, $(".list-news-content").map(function() { return $(this).height(); }));
      $(".list-news-content").each(function() {
        $(this).height(maxExcerpt);
      });
    }

    function alignNewsArchive(){
      $(".grid .grid-item .entry-summary .excerpt").height('auto');
      var maxExcerpt = Math.max.apply(Math, $(".grid .grid-item .entry-summary .excerpt").map(function() { return $(this).height(); }));
      $(".grid .grid-item .entry-summary .excerpt").each(function() {
        $(this).height(maxExcerpt);
      });
    }

    function alignNewsArchiveBody(){
      $(".grid .grid-item .inner").height('auto');
      var maxExcerpt = Math.max.apply(Math, $(".grid .grid-item .inner").map(function() { return $(this).height(); }));
      $(".grid .grid-item .inner").each(function() {
        $(this).height(maxExcerpt);
      });
    }

    function alignNewsArchiveImage(){
      $(".grid .grid-item .inner img").height('auto');
      var maxExcerpt = Math.max.apply(Math, $(".grid .grid-item .inner img").map(function() { return $(this).height(); }));
      $(".grid .grid-item .inner img").each(function() {
        $(this).height(maxExcerpt);
      });
    }

    function alignNewsArchiveHeading(){
      $(".grid .grid-item .inner h4").height('auto');
      var maxExcerpt = Math.max.apply(Math, $(".grid .grid-item .inner h4").map(function() { return $(this).height(); }));
      $(".grid .grid-item .inner h4").each(function() {
        $(this).height(maxExcerpt);
      });
    }

    $(window).resize(function(){
      alignNewsArchive();
      alignNewsArchiveBody();
      alignNewsArchiveImage();
      alignNewsArchiveHeading();
      alignRecruitmentNews();
      ctaBoxesAlign();
      prodSlideWidth();
    });

    $(window).load(function() {
      alignNewsArchive();
      alignNewsArchiveBody();
      alignNewsArchiveImage();
      alignNewsArchiveHeading();
      alignRecruitmentNews();
      ctaBoxesAlign();

      prodSlideWidth();
      window.onscroll = function() {
        growShrinkLogo()
      };

      function growShrinkLogo() {
        if( $(window).width() > 257){
          var Logo = document.getElementById("Logo")
          if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
            Logo.style.width = '125px';
          } else {
            Logo.style.width = '225px';
          }
        }
      }
    });

    //Masonry init
    $(window).load(function() {

      $('.grid').masonry({
        // set itemSelector so .grid-sizer is not used in layout
        itemSelector: '.grid-item',
        // use element for option
        columnWidth: '.grid-sizer',
        percentPosition: true,
      });
    });
  // Append privacy policy link to Job application form
  $( ".job-manager-application-form fieldset:nth-child(5) label" ).append( "<a href='http://www.clannadcare.ie/privacy-policy/' title='You must agree to the privacy policy to apply for this job'> Privacy Policy</a>" );

},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js